import React from 'react'
import { Briefcase, LogIn } from 'react-feather'
import { Box, Menu, MenuButton, MenuDivider, MenuItem, MenuList } from '@chakra-ui/react'
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons'

import UserInfo from './userInfo/UserInfo'
import { Divider } from '@wow/divider'

interface IUserMenuProps {
  userName: string
  companyName: string
  isDisablechangeCompany: boolean
  logoutAction: () => any
  changeCompany: () => any
}

const UserMenu: React.FC<IUserMenuProps> = ({ userName, companyName, isDisablechangeCompany, logoutAction, changeCompany }) => (
  <Menu closeOnSelect>
    <MenuButton
      as={Box}
      cursor='pointer'
      data-testid='userMenu-button'
      leftIcon={<ChevronDownIcon />}
      bg='whiteAlpha.600'
      borderRadius='16px'
      py={2}
      px={4}
      w='236px'
    >
      <UserInfo userName={userName} companyName={companyName} />
    </MenuButton>
    <MenuList p={4} mt='-65px' w='236px'>
      <UserInfo userName={userName} companyName={companyName} isActive />
      <Box fontSize='14px' lineHeight='16.94px'>
        <MenuItem icon={<Briefcase />} onClick={changeCompany} isDisabled={isDisablechangeCompany} p='8px 4px' m='14px 0 7px' borderRadius='4px' px={0}>Cambiar de empresa <ChevronRightIcon color='tertiary.800' /></MenuItem>
        <Divider />
        <MenuItem icon={<LogIn />} color='primary.500' onClick={logoutAction} p='4px' mt='7px' borderRadius='4px' data-testid='closeSesionButton'>Cerrar sesión</MenuItem>
      </Box>
    </MenuList>
  </Menu>
)

export default UserMenu
